import { useState } from 'react'
import { Navigation, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import { useFetchWinners } from 'api/queries/useFetchWinners'
import { AwardCard } from 'components/awardCard/AwardCard'
import { Button } from 'components/uikit/button/Button'

import { CarouselNextButton } from './CarouselNextButton'
import { CarouselPrevButton } from './CarouselPrevButton'

export default function CircularCarousel() {
  const { data: winners } = useFetchWinners()
  const [activeIndex, setActiveIndex] = useState(0)

  return (
    <div className="h-[608px] py-16 bg-[#191919]">
      <h2 className="pb-16 text-[48px] text-white font-bold text-center">These are the 2025 winners!</h2>
      <Swiper
        key={`swiper-winners-${winners.length}`}
        modules={[Navigation, Pagination]}
        loop={true}
        centeredSlides={true}
        slidesPerGroup={1}
        slidesPerView="auto"
        spaceBetween={40}
        loopAddBlankSlides={true}
        onSlideChange={({ realIndex }) => {
          setActiveIndex(realIndex ?? 0)
        }}
      >
        {winners.length > 0 &&
          winners.map((winner, index) => (
            <SwiperSlide key={index} className="!w-[35%]">
              <AwardCard award={winner} isActive={index === activeIndex} index={index} />
            </SwiperSlide>
          ))}
        <span slot="container-end">
          <CarouselNextButton className="absolute top-1/2 -translate-y-1/2 right-5" />
          <CarouselPrevButton className="absolute top-1/2 -translate-y-1/2 left-5" />
        </span>
      </Swiper>
      <div className="w-full mt-10 flex">
        <Button
          className="mx-auto"
          variant="secondary"
          onClick={() => {
            window.location.href = process.env.REACT_APP_GALLERY_2025_URL || ''
          }}
          text="Explore the 2025 Gallery"
        />
      </div>
    </div>
  )
}
